import { Link, useLocation } from '@/libs/router'
import { useIntlayer } from 'react-intlayer'
import { tv } from '@/libs/tv'

const navLink = tv({
	base: 'text-606060 text-sm whitespace-nowrap',
	variants: {
		active: {
			true: 'text-primary font-medium underline underline-offset-8',
		},
	},
})

type NavItem = {
	path: string
	label: string
}

const AccountNav = () => {
	const content = useIntlayer('account-nav')
	const location = useLocation()
	const items: NavItem[] = [
		{ path: '/account', label: content.general.value },
		{ path: '/account/date-and-locale', label: content.dateAndLocale.value },
		{ path: '/account/security', label: content.security.value },
	]

	return (
		<nav className='py-4'>
			<ul className='flex space-x-6 text-sm overflow-auto'>
				{items.map(item => (
					<li key={item.path}>
						<Link to={item.path} className={navLink({ active: location.pathname === item.path })}>
							{item.label}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	)
}

export { AccountNav }
